import * as Dialog from "@radix-ui/react-dialog"
import * as VisuallyHidden from "@radix-ui/react-visually-hidden"
import type { ReactNode } from "react"
import React from "react"
import { overlay, content, hiddenTitle, closeButton } from "./Modal.css"

interface ModalProps {
  isOpen: boolean
  onClose: () => void
  children: ReactNode
  trigger?: ReactNode
  title: string
}

export const Modal = ({
  isOpen,
  onClose,
  children,
  trigger,
  title,
}: ModalProps) => {
  return (
    <Dialog.Root open={isOpen} onOpenChange={(open) => !open && onClose()}>
      {trigger && <Dialog.Trigger asChild>{trigger}</Dialog.Trigger>}
      <Dialog.Portal>
        <Dialog.Overlay className={overlay} />
        <Dialog.Content className={content} aria-labelledby="dialog-title">
          <VisuallyHidden.Root>
            <Dialog.Title id="dialog-title" className={hiddenTitle}>
              {title}
            </Dialog.Title>
          </VisuallyHidden.Root>

          {children}

          <Dialog.Close asChild>
            <button className={closeButton} aria-label="Close">
              ✕
            </button>
          </Dialog.Close>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
